/** Claves para z-index dinámico; usar en getOverlayZIndex(key) y en acciones al abrir. */
export const OVERLAY_Z_INDEX_KEYS = {
	COMMANDER: "commander",
	PRODUCTS_CART: "productsCart",
	DETAILS_ACCOUNT: "detailsAccount",
	DETAILS_USER_ACCOUNT: "detailsUserAccount",
	QR_ACCOUNT: "qrAccount",
	QR_GOOGLE: "qrGoogle",
	HISTORIC_ACCOUNT_ORDERS: "historicAccountOrders",
	HISTORIC_ACCOUNT_TICKETS: "historicAccountTickets",
	HISTORIC_ACCOUNT_PROMOTIONS: "historicAccountPromotions",
	SELECT_TABLE: "selectTable",
	UPDATE_PAX_ACCOUNT: "updatePaxAccount",
	UPDATE_TABLE_ACCOUNT: "updateTableAccount",
	INFORMATION_PRODUCT: "informationProduct",
	COMPLETE_MENU_ACCOUNT: "completeMenuAccount",
	CONFIRM_REMOVE_PRODUCT_ACCOUNT: "confirmRemoveProductAccount",
	FINISH_ACCOUNT: "finishAccount",
	SEARCH_ACCOUNT: "searchAccount",
	PROMOTION_ACCOUNT: "promotionAccount",
	PRICE_MODIFY: "priceModify",
	PRODUCT_MENU: "productMenu",
	PRODUCT_OPTION_BREAKFAST: "productOptionBreakfast",
	CREATE_SIT_IN: "createSitIn",
	CREATE_WALK_IN: "createWalkIn",
	PRODUCT_COMMENT: "productComment",
	SCANNER_QR: "scannerQr",
	EDIT_MENUS: "editMenus",
	ELABORATION_STATION_SELECTOR: "elaborationStationSelector",
	FAST_PAID_CARD: "fastPaidCard",
	FAST_PAID_CASH: "fastPaidCash",
	INTERNAL_COMMENT: "internalComment",
	CREATE_ACCOUNT: "createAccount",
	SELECTED_ACCOUNT_COMMANDER: "selectedAccountCommander",
	READY_TO_PAID: "readyToPaid",
	INCENTIVE_GOALS: "incentiveGoals",
};

const state = {
	isShowOverlayCopilotConfig: false,
	isShowOverlayEditMenus: false,
	isShowOverlayInternalComment: false,
	isShowOverlayNewReservationPhone: false,
	isShowOverlayProductAvailabilityManager: false,
	isShowOverlayHistoricNotificationsAudio: false,
	isShowOverlayUpdatePaxAccount: false,
	isShowOverlayQRGoogle: false,
	isShowOverlayQRWePass: false,
	isShowOverlayDetailsUserAccount: false,
	isShowOverlayDetailsAccount: false,
	isShowOverlayQRAccount: false,
	isShowOverlayHistoricProductsAccount: false,
	isShowOverlayHistoricAccountOrders: false,
	isShowOverlayHistoricAccountTickets: false,
	isShowOverlayHistoricAccountPromotions: false,
	isShowOverlayCreateSitIn: false,
	isShowOverlayNotificationsDrinksPending: false,
	isShowOverlayNotificationsPending: false,
	isShowOverlayCompleteMenuAccount: false,
	isShowOverlayConfirmRemoveProductAccount: false,
	isShowOverlayScannerQR: false,
	isShowOverlayCreateWalkIn: false,
	isShowOverlayUpdateTableAccount: false,
	isShowOverlayFinishAccount: false,
	isShowOverlaySearchAccount: false,
	isShowOverlayNotificationsReadyPayment: false,
	isShowOverlayNotificationsNewOrder: false,
	isShowOverlayNotificationsOrderReady: false,
	isShowOverlayNotificationUpsellingDrinksReminder: false,
	isShowOverlayPromotionAccount: false,
	isShowOverlayFastPaidCard: false,
	isShowOverlayFastPaidCash: false,
	isShowOverlayNotificationsAccountKiosk: false,
	isShowOverlayInformationProduct: false,
	isShowOverlayProductsCart: false,
	isShowOverlayProductComment: false,
	overlayProductCommentUseOptionsAware: false,
	isShowOverlayCommander: false,
	isShowOverlayProductMenu: false,
	isShowOverlayProductOptionBreakfasts: false,
	isShowOverlayCashRegisterClosing: false,
	isShowOverlayFinalizedReservationsKitchen: false,
	isShowOverlayAllReservationsKitchen: false,
	isShowOverlayServedHistoryKitchen: false,
	isShowOverlayServedHistory: false,
	isShowOverlayNotificationsCallStaff: false,
	isShowOverlaySearchAccountZones: false,
	isShowOverlayPriceModify: false,
	isShowOverlayPinCodeEntry: false,
	isShowOverlayElaborationStationSelector: false,
	isShowOverlayIncentiveGoals: false,
	/** Si está definido, el modal de objetivos muestra este empleado; si es null, se usa currentStaff. */
	incentiveGoalsStaffId: null,
	isShowOverlaySelectTable: false,
	isShowOverlayCreateAccount: false,
	isShowOverlaySelectedAccountCommander: false,
	overlaySelectedAccountCommanderMode: true,
	isShowOverlayReadyToPaid: false,
	/** Mapa clave overlay → z-index asignado al abrir. Al cerrar se quita la clave; el siguiente z-index es max(abiertos)+1. */
	overlayZIndexByKey: {},
};

const getters = {
	getIsShowOverlayCopilotConfig(state) {
		return state.isShowOverlayCopilotConfig;
	},
	getIsShowOverlayEditMenus(state) {
		return state.isShowOverlayEditMenus;
	},
	getIsShowOverlayInternalComment(state) {
		return state.isShowOverlayInternalComment;
	},
	getIsShowOverlayNewReservationPhone(state) {
		return state.isShowOverlayNewReservationPhone;
	},
	getIsShowOverlayProductAvailabilityManager(state) {
		return state.isShowOverlayProductAvailabilityManager;
	},
	getIsShowOverlayHistoricNotificationsAudio(state) {
		return state.isShowOverlayHistoricNotificationsAudio;
	},
	getIsShowOverlayUpdatePaxAccount(state) {
		return state.isShowOverlayUpdatePaxAccount;
	},
	getIsShowOverlayQRGoogle(state) {
		return state.isShowOverlayQRGoogle;
	},
	getIsShowOverlayQRWePass(state) {
		return state.isShowOverlayQRWePass;
	},
	getIsShowOverlayDetailsUserAccount(state) {
		return state.isShowOverlayDetailsUserAccount;
	},
	getIsShowOverlayDetailsAccount(state) {
		return state.isShowOverlayDetailsAccount;
	},
	getIsShowOverlayQRAccount(state) {
		return state.isShowOverlayQRAccount;
	},
	getIsShowOverlayHistoricProductsAccount(state) {
		return state.isShowOverlayHistoricProductsAccount;
	},
	getIsShowOverlayHistoricAccountOrders(state) {
		return state.isShowOverlayHistoricAccountOrders;
	},
	getIsShowOverlayHistoricAccountTickets(state) {
		return state.isShowOverlayHistoricAccountTickets;
	},
	getIsShowOverlayHistoricAccountPromotions(state) {
		return state.isShowOverlayHistoricAccountPromotions;
	},
	getIsShowOverlayCreateSitIn(state) {
		return state.isShowOverlayCreateSitIn;
	},
	getIsShowOverlayNotificationsDrinksPending(state) {
		return state.isShowOverlayNotificationsDrinksPending;
	},
	getIsShowOverlayNotificationsPending(state) {
		return state.isShowOverlayNotificationsPending;
	},
	getIsShowOverlayCompleteMenuAccount(state) {
		return state.isShowOverlayCompleteMenuAccount;
	},
	getIsShowOverlayConfirmRemoveProductAccount(state) {
		return state.isShowOverlayConfirmRemoveProductAccount;
	},
	getIsShowOverlayScannerQR(state) {
		return state.isShowOverlayScannerQR;
	},
	getIsShowOverlayCreateWalkIn(state) {
		return state.isShowOverlayCreateWalkIn;
	},
	getIsShowOverlayUpdateTableAccount(state) {
		return state.isShowOverlayUpdateTableAccount;
	},
	getIsShowOverlayFinishAccount(state) {
		return state.isShowOverlayFinishAccount;
	},
	getIsShowOverlaySearchAccount(state) {
		return state.isShowOverlaySearchAccount;
	},
	getIsShowOverlayNotificationsReadyPayment(state) {
		return state.isShowOverlayNotificationsReadyPayment;
	},
	getIsShowOverlayNotificationsNewOrder(state) {
		return state.isShowOverlayNotificationsNewOrder;
	},
	getIsShowOverlayNotificationsOrderReady(state) {
		return state.isShowOverlayNotificationsOrderReady;
	},
	getIsShowOverlayNotificationUpsellingDrinksReminder(state) {
		return state.isShowOverlayNotificationUpsellingDrinksReminder;
	},
	getIsShowOverlayPromotionAccount(state) {
		return state.isShowOverlayPromotionAccount;
	},
	getIsShowOverlayFastPaidCard(state) {
		return state.isShowOverlayFastPaidCard;
	},
	getIsShowOverlayFastPaidCash(state) {
		return state.isShowOverlayFastPaidCash;
	},
	getIsShowOverlayNotificationsAccountKiosk(state) {
		return state.isShowOverlayNotificationsAccountKiosk;
	},
	getIsShowOverlayInformationProduct(state) {
		return state.isShowOverlayInformationProduct;
	},

	getIsShowOverlayProductMenu(state) {
		return state.isShowOverlayProductMenu;
	},

	getIsShowOverlayProductsCart(state) {
		return state.isShowOverlayProductsCart;
	},
	getIsShowOverlayProductComment(state) {
		return state.isShowOverlayProductComment;
	},
	getOverlayProductCommentUseOptionsAware(state) {
		return state.overlayProductCommentUseOptionsAware;
	},
	getIsShowOverlayCommander(state) {
		return state.isShowOverlayCommander;
	},
	getIsShowProductMenu(state) {
		return state.isShowOverlayProductMenu;
	},
	getIsShowProductOptionBreakfasts(state) {
		return state.isShowOverlayProductOptionBreakfasts;
	},
	getIsShowCashRegisterClosing(state) {
		return state.isShowOverlayCashRegisterClosing;
	},
	getIsShowFinalizedReservationsKitchen(state) {
		return state.isShowOverlayFinalizedReservationsKitchen;
	},
	getIsShowAllReservationsKitchen(state) {
		return state.isShowOverlayAllReservationsKitchen;
	},
	getIsShowServedHistoryKitchen(state) {
		return state.isShowOverlayServedHistoryKitchen;
	},
	getIsShowOverlayServedHistory(state) {
		return state.isShowOverlayServedHistory;
	},
	getIsShowOverlayNotificationsCallStaff(state) {
		return state.isShowOverlayNotificationsCallStaff;
	},
	getIsShowOverlaySearchAccountZones(state) {
		return state.isShowOverlaySearchAccountZones;
	},
	getIsShowOverlayPriceModify(state) {
		return state.isShowOverlayPriceModify;
	},
	getIsShowOverlayPinCodeEntry(state) {
		return state.isShowOverlayPinCodeEntry;
	},
	getIsShowOverlayElaborationStationSelector(state) {
		return state.isShowOverlayElaborationStationSelector;
	},
	getIsShowOverlayIncentiveGoals(state) {
		return state.isShowOverlayIncentiveGoals;
	},
	getIncentiveGoalsStaffId(state) {
		return state.incentiveGoalsStaffId;
	},
	getIsShowOverlaySelectTable(state) {
		return state.isShowOverlaySelectTable;
	},
	getIsShowOverlayCreateAccount(state) {
		return state.isShowOverlayCreateAccount;
	},
	getIsShowOverlaySelectedAccountCommander(state) {
		return state.isShowOverlaySelectedAccountCommander;
	},
	getIsShowOverlayReadyToPaid(state) {
		return state.isShowOverlayReadyToPaid;
	},
	getOverlaySelectedAccountCommanderMode(state) {
		return state.overlaySelectedAccountCommanderMode;
	},
	/** Z-index asignado a un overlay por clave. Uso: getOverlayZIndex('updateTableAccount') ?? 100 */
	getOverlayZIndex(state) {
		return (key, fallback = null) => state.overlayZIndexByKey[key] ?? fallback;
	},
};

const mutations = {
	SET_IS_SHOW_OVERLAY_COPILOT_CONFIG(state, payload) {
		state.isShowOverlayCopilotConfig = payload;
	},
	SET_IS_SHOW_OVERLAY_EDIT_MENUS(state, payload) {
		state.isShowOverlayEditMenus = payload;
	},
	SET_IS_SHOW_OVERLAY_INTERNAL_COMMENT(state, payload) {
		state.isShowOverlayInternalComment = payload;
	},
	SET_IS_SHOW_OVERLAY_NEW_RESERVATION_PHONE(state, payload) {
		state.isShowOverlayNewReservationPhone = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_AVAILABILITY_MANAGER(state, payload) {
		state.isShowOverlayProductAvailabilityManager = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_NOTIFICATIONS_AUDIO(state, payload) {
		state.isShowOverlayHistoricNotificationsAudio = payload;
	},
	SET_IS_SHOW_OVERLAY_UPDATE_PAX_ACCOUNT(state, payload) {
		state.isShowOverlayUpdatePaxAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_QR_GOOGLE(state, payload) {
		state.isShowOverlayQRGoogle = payload;
	},
	SET_IS_SHOW_OVERLAY_QR_WEPASS(state, payload) {
		state.isShowOverlayQRWePass = payload;
	},
	SET_IS_SHOW_OVERLAY_DETAILS_USER_ACCOUNT(state, payload) {
		state.isShowOverlayDetailsUserAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_DETAILS_ACCOUNT(state, payload) {
		state.isShowOverlayDetailsAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_QR_ACCOUNT(state, payload) {
		state.isShowOverlayQRAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_PRODUCTS_ACCOUNT(state, payload) {
		state.isShowOverlayHistoricProductsAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_ORDERS(state, payload) {
		state.isShowOverlayHistoricAccountOrders = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_TICKETS(state, payload) {
		state.isShowOverlayHistoricAccountTickets = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_PROMOTIONS(state, payload) {
		state.isShowOverlayHistoricAccountPromotions = payload;
	},
	SET_IS_SHOW_OVERLAY_CREATE_SIT_IN(state, payload) {
		state.isShowOverlayCreateSitIn = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_DRINKS_PENDING(state, payload) {
		state.isShowOverlayNotificationsDrinksPending = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_PENDING(state, payload) {
		state.isShowOverlayNotificationsPending = payload;
	},
	SET_IS_SHOW_OVERLAY_COMPLETE_MENU_ACCOUNT(state, payload) {
		state.isShowOverlayCompleteMenuAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_CONFIRM_REMOVE_PRODUCT_ACCOUNT(state, payload) {
		state.isShowOverlayConfirmRemoveProductAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_SCANNER_QR(state, payload) {
		state.isShowOverlayScannerQR = payload;
	},
	SET_IS_SHOW_OVERLAY_CREATE_WALK_IN(state, payload) {
		state.isShowOverlayCreateWalkIn = payload;
	},
	SET_IS_SHOW_OVERLAY_UPDATE_TABLE_ACCOUNT(state, payload) {
		state.isShowOverlayUpdateTableAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_FINISH_ACCOUNT(state, payload) {
		state.isShowOverlayFinishAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT(state, payload) {
		state.isShowOverlaySearchAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_READY_PAYMENT(state, payload) {
		state.isShowOverlayNotificationsReadyPayment = payload;
	},
	SET_IS_SHOW_OVERLAY_NEW_ORDER(state, payload) {
		state.isShowOverlayNotificationsNewOrder = payload;
	},
	SET_IS_SHOW_OVERLAY_ORDER_READY(state, payload) {
		state.isShowOverlayNotificationsOrderReady = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_UPSELLING_DRINKS_REMINDER(state, payload) {
		state.isShowOverlayNotificationUpsellingDrinksReminder = payload;
	},
	SET_IS_SHOW_OVERLAY_PROMOTION_ACCOUNT(state, payload) {
		state.isShowOverlayPromotionAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_FAST_PAID_CARD(state, payload) {
		state.isShowOverlayFastPaidCard = payload;
	},
	SET_IS_SHOW_OVERLAY_FAST_PAID_CASH(state, payload) {
		state.isShowOverlayFastPaidCash = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_ACCOUNT_KIOSK(state, payload) {
		state.isShowOverlayNotificationsAccountKiosk = payload;
	},
	SET_IS_SHOW_OVERLAY_INFORMATION_PRODUCT(state, payload) {
		state.isShowOverlayInformationProduct = payload;
	},
	SET_OVERLAY_Z_INDEX(state, { key, value }) {
		state.overlayZIndexByKey[key] = value;
	},
	/** Quita la clave del mapa al cerrar el overlay para que el siguiente z-index sea el de los que siguen abiertos. */
	REMOVE_OVERLAY_Z_INDEX(state, key) {
		delete state.overlayZIndexByKey[key];
	},
	SET_IS_SHOW_OVERLAY_PRODUCTS_CART(state, payload) {
		state.isShowOverlayProductsCart = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_COMMENT(state, payload) {
		state.isShowOverlayProductComment = payload;
	},
	SET_OVERLAY_PRODUCT_COMMENT_USE_OPTIONS_AWARE(state, payload) {
		state.overlayProductCommentUseOptionsAware = payload;
	},
	SET_IS_SHOW_OVERLAY_COMMANDER(state, payload) {
		state.isShowOverlayCommander = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_MENU(state, payload) {
		state.isShowOverlayProductMenu = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_OPTION_BREAKFAST(state, payload) {
		state.isShowOverlayProductOptionBreakfasts = payload;
	},
	SET_IS_SHOW_OVERLAY_CASH_REGISTER_CLOSING(state, payload) {
		state.isShowOverlayCashRegisterClosing = payload;
	},
	SET_IS_SHOW_OVERLAY_FINALIZED_RESERVATIONS_KITCHEN(state, payload) {
		state.isShowOverlayFinalizedReservationsKitchen = payload;
	},
	SET_IS_SHOW_OVERLAY_ALL_RESERVATIONS_KITCHEN(state, payload) {
		state.isShowOverlayAllReservationsKitchen = payload;
	},
	SET_IS_SHOW_OVERLAY_SERVED_HISTORY_KITCHEN(state, payload) {
		state.isShowOverlayServedHistoryKitchen = payload;
	},
	SET_IS_SHOW_OVERLAY_SERVED_HISTORY(state, payload) {
		state.isShowOverlayServedHistory = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_CALL_STAFF(state, payload) {
		state.isShowOverlayNotificationsCallStaff = payload;
	},
	SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT_ZONES(state, payload) {
		state.isShowOverlaySearchAccountZones = payload;
	},
	SET_IS_SHOW_OVERLAY_PRICE_MODIFY(state, payload) {
		state.isShowOverlayPriceModify = payload;
	},
	SET_IS_SHOW_OVERLAY_PIN_CODE_ENTRY(state, payload) {
		state.isShowOverlayPinCodeEntry = payload;
	},
	SET_IS_SHOW_OVERLAY_ELABORATION_STATION_SELECTOR(state, payload) {
		state.isShowOverlayElaborationStationSelector = payload;
	},
	SET_IS_SHOW_OVERLAY_INCENTIVE_GOALS(state, payload) {
		state.isShowOverlayIncentiveGoals = payload;
	},
	SET_INCENTIVE_GOALS_STAFF_ID(state, payload) {
		state.incentiveGoalsStaffId = payload;
	},
	SET_IS_SHOW_OVERLAY_SELECT_TABLE(state, payload) {
		state.isShowOverlaySelectTable = payload;
	},
	SET_IS_SHOW_OVERLAY_CREATE_ACCOUNT(state, payload) {
		state.isShowOverlayCreateAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_SELECTED_ACCOUNT_COMMANDER(state, payload) {
		state.isShowOverlaySelectedAccountCommander = payload;
	},
	SET_OVERLAY_SELECTED_ACCOUNT_COMMANDER_MODE(state, payload) {
		state.overlaySelectedAccountCommanderMode = payload === true || payload === false ? payload : true;
	},
	SET_IS_SHOW_OVERLAY_READY_TO_PAID(state, payload) {
		state.isShowOverlayReadyToPaid = payload;
	},
};

const actions = {
	/** Devuelve el siguiente z-index: máximo de los overlays abiertos + 1 (base 100 si no hay ninguno). */
	getNextOverlayZIndex({ state }) {
		const values = Object.values(state.overlayZIndexByKey);
		const maxZ = values.length ? Math.max(...values) : 0;
		return Math.max(100, maxZ + 1);
	},
	setIsShowOverlayCopilotConfig({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_COPILOT_CONFIG", payload);
	},
	async setIsShowOverlayEditMenus({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.EDIT_MENUS, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.EDIT_MENUS);
		}
		commit("SET_IS_SHOW_OVERLAY_EDIT_MENUS", payload);
	},
	async setIsShowOverlayInternalComment({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.INTERNAL_COMMENT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.INTERNAL_COMMENT);
		}
		commit("SET_IS_SHOW_OVERLAY_INTERNAL_COMMENT", payload);
	},
	setIsShowOverlayNewReservationPhone({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NEW_RESERVATION_PHONE", payload);
	},
	setIsShowOverlayProductAvailabilityManager({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_AVAILABILITY_MANAGER", payload);
	},
	setIsShowOverlayHistoricNotificationsAudio({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_NOTIFICATIONS_AUDIO", payload);
	},
	async setIsShowOverlayUpdatePaxAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.UPDATE_PAX_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.UPDATE_PAX_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_UPDATE_PAX_ACCOUNT", payload);
	},
	async setIsShowOverlayQRGoogle({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.QR_GOOGLE, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.QR_GOOGLE);
		}
		commit("SET_IS_SHOW_OVERLAY_QR_GOOGLE", payload);
	},
	setIsShowOverlayQRWePass({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_QR_WEPASS", payload);
	},
	async setIsShowOverlayDetailsUserAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.DETAILS_USER_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.DETAILS_USER_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_DETAILS_USER_ACCOUNT", payload);
	},
	async setIsShowOverlayDetailsAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.DETAILS_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.DETAILS_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_DETAILS_ACCOUNT", payload);
	},
	async setIsShowOverlayQRAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.QR_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.QR_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_QR_ACCOUNT", payload);
	},
	setIsShowOverlayHistoricProductsAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_PRODUCTS_ACCOUNT", payload);
	},
	async setIsShowOverlayHistoricAccountOrders({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_ORDERS, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_ORDERS);
		}
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_ORDERS", payload);
	},
	async setIsShowOverlayHistoricAccountTickets({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_TICKETS, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_TICKETS);
		}
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_TICKETS", payload);
	},
	async setIsShowOverlayHistoricAccountPromotions({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_PROMOTIONS, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.HISTORIC_ACCOUNT_PROMOTIONS);
		}
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_ACCOUNT_PROMOTIONS", payload);
	},
	async setIsShowOverlayCreateSitIn({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.CREATE_SIT_IN, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.CREATE_SIT_IN);
		}
		commit("SET_IS_SHOW_OVERLAY_CREATE_SIT_IN", payload);
	},
	setIsShowOverlayNotificationsDrinksPending({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_DRINKS_PENDING", payload);
	},
	setIsShowOverlayNotificationsPending({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_PENDING", payload);
	},
	async setIsShowOverlayCompleteMenuAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.COMPLETE_MENU_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.COMPLETE_MENU_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_COMPLETE_MENU_ACCOUNT", payload);
	},
	async setIsShowOverlayConfirmRemoveProductAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.CONFIRM_REMOVE_PRODUCT_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.CONFIRM_REMOVE_PRODUCT_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_CONFIRM_REMOVE_PRODUCT_ACCOUNT", payload);
	},
	async setIsShowOverlayScannerQR({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.SCANNER_QR, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.SCANNER_QR);
		}
		commit("SET_IS_SHOW_OVERLAY_SCANNER_QR", payload);
	},
	async setIsShowOverlayCreateWalkIn({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.CREATE_WALK_IN, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.CREATE_WALK_IN);
		}
		commit("SET_IS_SHOW_OVERLAY_CREATE_WALK_IN", payload);
	},
	setIsShowOverlayUpdateTableAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_UPDATE_TABLE_ACCOUNT", payload);
	},
	async setIsShowOverlayFinishAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.FINISH_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.FINISH_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_FINISH_ACCOUNT", payload);
	},
	async setIsShowOverlaySearchAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.SEARCH_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.SEARCH_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT", payload);
	},
	setIsShowOverlayNotificationsReadyPayment({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_READY_PAYMENT", payload);
	},
	setIsShowOverlayNotificationsNewOrder({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NEW_ORDER", payload);
	},
	setIsShowOverlayNotificationsOrderReady({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_ORDER_READY", payload);
	},
	setIsShowOverlayNotificationUpsellingDrinksReminder({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_UPSELLING_DRINKS_REMINDER", payload);
	},
	async setIsShowOverlayPromotionAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PROMOTION_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PROMOTION_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_PROMOTION_ACCOUNT", payload);
	},
	async setIsShowOverlayFastPaidCard({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.FAST_PAID_CARD, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.FAST_PAID_CARD);
		}
		commit("SET_IS_SHOW_OVERLAY_FAST_PAID_CARD", payload);
	},
	async setIsShowOverlayFastPaidCash({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.FAST_PAID_CASH, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.FAST_PAID_CASH);
		}
		commit("SET_IS_SHOW_OVERLAY_FAST_PAID_CASH", payload);
	},
	setIsShowOverlayNotificationsAccountKiosk({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_ACCOUNT_KIOSK", payload);
	},
	async setIsShowOverlayInformationProduct({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.INFORMATION_PRODUCT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.INFORMATION_PRODUCT);
		}
		commit("SET_IS_SHOW_OVERLAY_INFORMATION_PRODUCT", payload);
	},
	setIsShowOverlayProductsCart({ commit }, payload) {
		if (!payload) {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PRODUCTS_CART);
		}
		commit("SET_IS_SHOW_OVERLAY_PRODUCTS_CART", payload);
	},
	async setIsShowOverlayProductComment({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PRODUCT_COMMENT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PRODUCT_COMMENT);
		}
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_COMMENT", payload);
	},
	setOverlayProductCommentUseOptionsAware({ commit }, payload) {
		commit("SET_OVERLAY_PRODUCT_COMMENT_USE_OPTIONS_AWARE", payload);
	},
	async setIsShowOverlayCommander({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.COMMANDER, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.COMMANDER);
		}
		commit("SET_IS_SHOW_OVERLAY_COMMANDER", payload);
	},
	/** Asigna el siguiente z-index al modal del carrito para que quede por encima del Commander. */
	async setOverlayZIndexForProductsCart({ commit, dispatch }) {
		const z = await dispatch("getNextOverlayZIndex");
		commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PRODUCTS_CART, value: z });
	},
	async setIsShowOverlayProductMenu({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PRODUCT_MENU, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PRODUCT_MENU);
		}
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_MENU", payload);
	},
	async setIsShowOverlayProductOptionBreakfast({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PRODUCT_OPTION_BREAKFAST, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PRODUCT_OPTION_BREAKFAST);
		}
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_OPTION_BREAKFAST", payload);
	},
	setIsShowOverlayCashRegisterClosing({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_CASH_REGISTER_CLOSING", payload);
	},
	setIsShowOverlayFinalizedReservationsKitchen({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_FINALIZED_RESERVATIONS_KITCHEN", payload);
	},
	setIsShowOverlayAllReservationsKitchen({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_ALL_RESERVATIONS_KITCHEN", payload);
	},
	setIsShowOverlayServedHistoryKitchen({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SERVED_HISTORY_KITCHEN", payload);
	},
	setIsShowOverlayServedHistory({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SERVED_HISTORY", payload);
	},
	setIsShowOverlayNotificationsCallStaff({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_CALL_STAFF", payload);
	},
	setIsShowOverlaySearchAccountZones({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT_ZONES", payload);
	},
	async setIsShowOverlayPriceModify({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.PRICE_MODIFY, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.PRICE_MODIFY);
		}
		commit("SET_IS_SHOW_OVERLAY_PRICE_MODIFY", payload);
	},
	setIsShowOverlayPinCodeEntry({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PIN_CODE_ENTRY", payload);
	},
	async setIsShowOverlayElaborationStationSelector({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.ELABORATION_STATION_SELECTOR, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.ELABORATION_STATION_SELECTOR);
		}
		commit("SET_IS_SHOW_OVERLAY_ELABORATION_STATION_SELECTOR", payload);
	},
	async setIsShowOverlayIncentiveGoals({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.INCENTIVE_GOALS, value: z });
			commit("SET_INCENTIVE_GOALS_STAFF_ID", null);
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.INCENTIVE_GOALS);
			commit("SET_INCENTIVE_GOALS_STAFF_ID", null);
		}
		commit("SET_IS_SHOW_OVERLAY_INCENTIVE_GOALS", payload);
	},
	setIncentiveGoalsStaffId({ commit }, staffId) {
		commit("SET_INCENTIVE_GOALS_STAFF_ID", staffId);
	},
	async setIsShowOverlaySelectTable({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.SELECT_TABLE, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.SELECT_TABLE);
		}
		commit("SET_IS_SHOW_OVERLAY_SELECT_TABLE", payload);
	},
	async setIsShowOverlayCreateAccount({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.CREATE_ACCOUNT, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.CREATE_ACCOUNT);
		}
		commit("SET_IS_SHOW_OVERLAY_CREATE_ACCOUNT", payload);
	},
	async setIsShowOverlaySelectedAccountCommander({ commit, dispatch }, payload) {
		const isShow = typeof payload === "object" && payload !== null ? payload.show : payload;
		const commander = typeof payload === "object" && payload !== null && "commander" in payload ? payload.commander : undefined;
		if (isShow) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.SELECTED_ACCOUNT_COMMANDER, value: z });
			if (commander !== undefined) {
				commit("SET_OVERLAY_SELECTED_ACCOUNT_COMMANDER_MODE", commander);
			}
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.SELECTED_ACCOUNT_COMMANDER);
		}
		commit("SET_IS_SHOW_OVERLAY_SELECTED_ACCOUNT_COMMANDER", isShow);
	},
	async setIsShowOverlayReadyToPaid({ commit, dispatch }, payload) {
		if (payload) {
			const z = await dispatch("getNextOverlayZIndex");
			commit("SET_OVERLAY_Z_INDEX", { key: OVERLAY_Z_INDEX_KEYS.READY_TO_PAID, value: z });
		} else {
			commit("REMOVE_OVERLAY_Z_INDEX", OVERLAY_Z_INDEX_KEYS.READY_TO_PAID);
		}
		commit("SET_IS_SHOW_OVERLAY_READY_TO_PAID", payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
